import ErrorPage, { TProps, links, resultMap } from './Error'

export type { TProps }
export { links, resultMap }
export default ErrorPage
